import {Plugins} from '@packages/systems/wfdl';
import {
  tyfun,
  forall,
  a,
  $,
  call,
  func,
} from '@packages/utilities/wfdl-helpers';
import {
  TBoolean,
  TPredicate,
  runPredicate,
} from '@packages/systems/plugins-utils/Boolean';
import {
  TOperand,
  FromOperand,
} from '@packages/systems/plugins/ConditionsOperand';

export const plugin = Plugins.PrivilegedPlugin({
  values: {
    'Apply predicate': {
      envType: {
        dataType: forall(['a'], tyfun([TOperand(a), TPredicate(a)], TBoolean)),
        exported: 'hidden',
      },
      expression: func(
        ['operand', 'predicate'],
        call(runPredicate($('predicate')), [FromOperand($('operand'))])
      ),
    },
  },
});
